import { render } from "./contactmodal.vue?vue&type=template&id=70615d29&scoped=true"
import script from "./contactmodal.vue?vue&type=script&lang=js"
export * from "./contactmodal.vue?vue&type=script&lang=js"

import "./contactmodal.vue?vue&type=style&index=0&id=70615d29&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70615d29"]])

export default __exports__